import React from 'react';

const modalOverlayStyle = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.35)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};

const modalBoxStyle = {
  background: '#fef0ef',
  borderRadius: '16px',
  width: '100%',
  maxWidth: '340px',
  padding: '0',
  boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
  border: '1px solid #f5c6c6',
  fontFamily: "'DM Sans', sans-serif",
  overflow: 'hidden',
  position: 'relative',
};

const headerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '18px 20px 14px 20px',
  borderBottom: '1px solid #f5c6c6',
};

const closeButtonStyle = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  color: '#d94040',
  fontSize: '22px',
  lineHeight: 1,
  padding: '0',
  fontWeight: '400',
};

const bodyStyle = {
  padding: '16px 20px 24px 20px',
};

const headingStyle = {
  fontFamily: "'DM Sans', sans-serif",
  fontWeight: '700',
  fontSize: '15px',
  color: '#d94040',
  textDecoration: 'underline',
  textDecorationColor: '#d94040',
  marginBottom: '16px',
  lineHeight: '1.4',
};

const listStyle = {
  paddingLeft: '4px',
  margin: '0',
  listStyle: 'none',
};

const listItemStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',
  marginBottom: '14px',
  fontSize: '13.5px',
  color: '#4a4a4a',
  lineHeight: '1.5',
};

const bulletStyle = {
  width: '6px',
  height: '6px',
  borderRadius: '50%',
  background: '#4a4a4a',
  flexShrink: 0,
  marginTop: '7px',
};




/* ─── PayTo Modal ─── */
export const PayToInst = ({ show, handler }) => {
  if (!show) return null;

  return (
    <>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap" rel="stylesheet" />
      <div style={modalOverlayStyle} onClick={handler}>
        <div style={modalBoxStyle} onClick={(e) => e.stopPropagation()}>
          {/* Header */}
          <div style={headerStyle}>
            <img src="/assets/img/zai/payto.svg" height={28} alt="PayTo" style={{ filter: 'invert(27%) sepia(90%) saturate(1200%) hue-rotate(330deg) brightness(90%) contrast(110%)' }} />
            <button style={closeButtonStyle} onClick={handler}>✕</button>
          </div>

          {/* Body */}
          <div style={bodyStyle}>
            <p style={headingStyle}>Instructions to use PayTo as a payment method</p>
            <ul style={listStyle}>
              <li style={listItemStyle}>
                <span style={bulletStyle} />
                <span>Create a PayTo agreement authorising us to debit your account for transaction.</span>
              </li>
              <li style={listItemStyle}>
                <span style={bulletStyle} />
                <span>We initiate a request to your financial institution for the payment.</span>
              </li>
              <li style={listItemStyle}>
                <span style={bulletStyle} />
                <span>You log on to your booking portal or app to review and approve the payment for your transaction.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};


/* ─── PayID Modal ─── */
export const PayIDInst = ({ show, handler }) => {
  if (!show) return null;

  return (
    <>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap" rel="stylesheet" />
      <div style={modalOverlayStyle} onClick={handler}>
        <div style={modalBoxStyle} onClick={(e) => e.stopPropagation()}>
          {/* Header */}
          <div style={headerStyle}>
            <img src="/assets/img/zai/payid.svg" height={28} alt="PayID" style={{ filter: 'invert(27%) sepia(90%) saturate(1200%) hue-rotate(330deg) brightness(90%) contrast(110%)' }} />
            <button style={closeButtonStyle} onClick={handler}>✕</button>
          </div>

          {/* Body */}
          <div style={bodyStyle}>
            <p style={headingStyle}>Instructions to use PayID as a payment method</p>
            <ul style={listStyle}>
              <li style={listItemStyle}>
                <span style={bulletStyle} />
                <span>Copy the generated PayID and Transaction ID.</span>
              </li>
              <li style={listItemStyle}>
                <span style={bulletStyle} />
                <span>Log on to your banking portal or app to initiate the payment for transaction to copied PayID.</span>
              </li>
              <li style={listItemStyle}>
                <span style={bulletStyle} />
                <span>Use transaction ID as reference number for the payment.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};